import React from 'react';

import { ActionContainer, ActionTextContainer } from './EmployerWidgetActions.styled';
import { Button } from 'components/v2/Buttons/Button/Button';
import { Text } from 'components/v2/Typography/Text';

import { EmployerWidgetCTA } from '../EmployerWidgets.types';

export const EmployerWidgetActions = ({
  actions
}: {
  actions: EmployerWidgetCTA[];
}): React.JSX.Element => (
  /*Fragment is needed here to prevent following error in SaicWidget and EmbryoIncWidget: 
  'EmployerWidgetActions' cannot be used as a JSX component.
    Its return type 'Element[]' is not a valid JSX element.
      Type 'Element[]' is missing the following properties from type 'Element' */
  <>
    {actions.map((action, index) => (
      <ActionContainer $last={index === actions.length - 1} key={`cta-${index}`}>
        <ActionTextContainer>
          <Text fontStyle="bold">{action.line1}</Text>
        </ActionTextContainer>
        <Button
          category="secondary"
          label={action.linkText}
          onClick={() => window.open(action.linkUrl, '_blank')}
        />
      </ActionContainer>
    ))}
  </>
);
